'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_ScheduledMealPreferences$$anon$13(ps$11) {
  this.a6z = null;
  this.a6z = ps$11;
}
export { $c_Lmealorama_ScheduledMealPreferences$$anon$13 as $c_Lmealorama_ScheduledMealPreferences$$anon$13 };
$p = $c_Lmealorama_ScheduledMealPreferences$$anon$13.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ScheduledMealPreferences$$anon$13;
/** @constructor */
function $h_Lmealorama_ScheduledMealPreferences$$anon$13() {
}
export { $h_Lmealorama_ScheduledMealPreferences$$anon$13 as $h_Lmealorama_ScheduledMealPreferences$$anon$13 };
$h_Lmealorama_ScheduledMealPreferences$$anon$13.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6z.a.length;
});
$p.g = (function(i) {
  return this.a6z.a[i];
});
var $d_Lmealorama_ScheduledMealPreferences$$anon$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ScheduledMealPreferences$$anon$13, "mealorama.ScheduledMealPreferences$$anon$13", ({
  GT: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_ScheduledMealPreferences$$anon$13 as $d_Lmealorama_ScheduledMealPreferences$$anon$13 };
//# sourceMappingURL=mealorama.-Scheduled-Meal-Preferences$$anon$13.js.map
